import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookiespageComponent } from '../../cookiespage/cookiespage.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor(private modalService: NgbModal,
    private router : Router) { }

  ngOnInit(): void {
  }


  opencookiespage(){
    const addmodalRef = this.modalService.open(CookiespageComponent, {
      size: 'md', backdrop: 'static', centered:true
    });
  }

}
